import { formatPrice } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';

interface PauseInfoMonthViewProps {
  normalColor?: string;
  activeColor?: string;
  info: {
    monthText: string;
    moneyText: string;
    statusText: string;
  };
  click?: (index: number) => void;
  index?: number;
  isActive?: boolean;
}

const PauseInfoMonthView = (props: PauseInfoMonthViewProps) => {
  const {
    info: { monthText, moneyText, statusText } = {},
    normalColor = '#F5F5F5',
    activeColor = '#BB33D51A',
    click,
    index,
    isActive,
  } = props;

  const clickAction = () => {
    if (click) click(index);
  };

  return (
    <Box
      className="flex w-full cursor-pointer flex-col items-center"
      onClick={clickAction}
    >
      <Box
        style={{
          backgroundColor:
            statusText.toLocaleLowerCase() === 'paid'
              ? normalColor
              : activeColor,
        }}
        className="flex w-full flex-col items-center rounded-md py-3"
      >
        <Typography className="font-bold" variant="subtitle1">
          {formatPrice(moneyText)}
        </Typography>
        <Typography className="font-medium" variant="caption">
          {statusText}
        </Typography>
      </Box>
      <Typography className="mt-2 font-bold" variant="subtitle1">
        {monthText}
      </Typography>
    </Box>
  );
};

export default PauseInfoMonthView;
